<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-input
            size="mini"
            v-model="params.ClassName"
            placeholder="点击选择"
            readonly
            @focus="onClassDialog"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model="params.StartDate"
            placeholder="请选择日期"
            clearable
            @input="sinput"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="开始节次">
          <el-select
            v-model="params.StartSectionId"
            size="mini"
            clearable
            :disabled="!params.StartDate"
          >
            <el-option
              v-for="item in sectionList"
              :key="item.SectionId"
              :value="item.SectionId"
              :label="item.SectionName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            v-model="params.EndDate"
            placeholder="请选择日期"
            @input="einput"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束节次">
          <el-select
            v-model="params.EndSectionId"
            size="mini"
            clearable
            :disabled="!params.EndDate"
          >
            <el-option
              v-for="item in sectionList"
              :key="item.SectionId"
              :value="item.SectionId"
              :label="item.SectionName"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="StudentNumber" label="学号" /> -->
        <el-table-column prop="FullName" label="学生姓名" />
        <el-table-column prop="ClassName" label="班级" min-width="90" />
        <el-table-column prop="LeaveType" label="请假类型" />
        <el-table-column prop="StartDate" label="请假开始日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StartSectionName" label="开始节次"></el-table-column>
        <el-table-column prop="EndDate" label="请假结束日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndSectionName" label="结束节次"></el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <class-dialog ref="classDialog" in-dialog selectable :multiple="false" @select="setClass" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import classDialog from "@/components/ed/class/listDialog";
import importDialog from "./importDialog";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, classDialog, exportDialog, importDialog },
  data() {
    return {
      api: require("@/api/st/leave").default,
      sectionApi: require("@/api/ed/section").default,
      params: {
        TermId: null,
        TermName: "",
        TeacherId: null,
        StartDate: "",
        EndDate: "",
        ClassId: null,
        StartSectionId: null,
        EndSectionId: null,
        ClassName: "",
      },
      GradeId: null,
      termApi,
      termList: [],
      sectionList: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.TeacherId = loginInfo.TeacherId;
    // this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        this.params.TermId = res.Data[0].TermId;
        this.params.TermName = res.Data[0].TermName;
        sessionStorage.setItem("termId", this.params.TermId);
        this.query({ TermId: res.Data[0].TermId });
      }
    });
  },
  methods: {
    onImport() {
      // this.$refs.importDialog.TermId = this.params.TermId;
      // this.$refs.importDialog.TermName = this.params.TermName;
      this.$refs.importDialog.open().then((that) => {
        that.setData(this.params);
      });
    },
    onExport() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    onClassDialog() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ TermId: this.params.TermId });
      });
    },
    setClass(c) {
      this.params.ClassId = c.ClassId;
      this.params.ClassName = c.Grade + c.Class;
      if (this.GradeId != c.GradeId) {
        this.GradeId = c.GradeId;
        this.params.StartSectionId = null;
        this.params.EndSectionId = null;
        this.sectionList = [];
        this.getSection(this.params.TermId, c.GradeId);
      }
    },
    getSection(TermId, GradeId) {
      if (TermId && GradeId) {
        this.sectionApi.list({ TermId, GradeId }).then((res) => {
          this.sectionList = res.Data;
        });
      }
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      var term = this.termList.find((x) => x.TermId == e);
      if (term) this.params.TermName = term.TermName;
      this.params.ClassName = "";
      this.params.ClassId = null;
      this.params.StartSectionId = null;
      this.params.EndSectionId = null;
      this.sectionList = [];
      this.query({
        TermId: e,
        ClassId: this.params.ClassId,
        StartDate: this.params.StartDate,
        EndDate: this.params.EndDate,
      });
    },
    sinput(e) {
      if (!e) {
        this.params.StartSectionId = null;
      }
    },
    einput(e) {
      if (!e) {
        this.params.EndSectionId = null;
      }
    },
  },
};
</script>
<style lang="scss">
.is-disabled .el-input__inner {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
}
</style>